import { ISetSubmitted, ISetTabStatus, ISetSettings, ISetLogoUrl } from './interfaces';
import { SET_SUBMITTED, SET_TAB_OPENED, SET_SETTINGS, SET_LOGO_URL } from './constants';

export function setSubmitted(isSubmitted: boolean): ISetSubmitted {
    return {
        type: SET_SUBMITTED,
        isSubmitted
    };
}

export function setTabStatus(tabId: string, opened: boolean): ISetTabStatus {
    return {
        type: SET_TAB_OPENED,
        tabId,
        opened
    };
}

export function setSettings(settings: {}): ISetSettings {
    return {
        type: SET_SETTINGS,
        settings
    };
}

export function setLogoUrl(logoUrl: string): ISetLogoUrl {
    return {
        type: SET_LOGO_URL,
        logoUrl
    };
}
